// A tela do link de criar senha (pedido do Ilton, 30/09).
//
// Quem recebe o link cria a própria senha aqui, sem senha provisória nenhuma: a
// senha nasce conhecida só por quem a digitou. O token vem no fragmento do
// endereço (/criar-senha#token), que o navegador não manda ao servidor; esta
// tela o lê e o envia no corpo do pedido. Depois de usado, o link morre.
import { useEffect, useState, type FormEvent } from 'react';
import { chamar } from '../api';

interface Conta { nome: string; usuario: string; expiraEm: string }

const tokenDoEndereco = () => window.location.hash.replace(/^#/, '').trim();

export function CriarSenha() {
  const [token] = useState(tokenDoEndereco);
  const [conta, setConta] = useState<Conta | null>(null);
  const [invalido, setInvalido] = useState('');
  const [senhaNova, setSenhaNova] = useState('');
  const [repetida, setRepetida] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!token) { setInvalido('Este link está incompleto. Abra o link inteiro, do jeito que você recebeu.'); return; }
    chamar<Conta>('/convites-senha/consultar', { metodo: 'POST', corpo: { token } })
      .then(setConta)
      .catch((e) => setInvalido(e instanceof Error ? e.message : 'Este link não vale mais.'));
  }, [token]);

  const curta = senhaNova.length > 0 && senhaNova.length < 8;
  const diferem = repetida.length > 0 && senhaNova !== repetida;
  const podeSalvar = senhaNova.length >= 8 && senhaNova === repetida && !salvando;

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    if (!podeSalvar) return;
    setErro('');
    setSalvando(true);
    try {
      await chamar('/convites-senha/usar', { metodo: 'POST', corpo: { token, senhaNova } });
      // Já entrou (a API abriu a sessão): tira o token do endereço e abre o app.
      window.location.replace('/');
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não consegui criar a senha.');
      setSalvando(false);
    }
  }

  return (
    <main style={{ display: 'grid', placeItems: 'center', minHeight: '100%', padding: 'var(--gap-4)' }}>
      <form onSubmit={enviar} className="cartao" style={{ width: 'min(100%, 380px)', display: 'grid', gap: 'var(--gap-4)' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--serif)', fontSize: 25, fontWeight: 400 }}>Criar a senha</h1>
          {conta && (
            <p style={{ color: 'var(--texto-2)', fontSize: 14, lineHeight: 1.5, marginTop: 6 }}>
              Conta <b>{conta.usuario}</b> ({conta.nome}). É com este nome de usuário e a senha
              que você criar aqui que se entra no sistema.
            </p>
          )}
          {!conta && !invalido && <p style={{ color: 'var(--texto-3)', fontSize: 14, marginTop: 6 }}>conferindo o link…</p>}
        </div>

        {invalido ? (
          <p className="aviso-erro">{invalido}</p>
        ) : conta && (
          <>
            <div className="campo">
              <label htmlFor="nova">Nova senha</label>
              <input id="nova" type="password" autoComplete="new-password" required autoFocus
                value={senhaNova} onChange={(e) => setSenhaNova(e.target.value)} />
              <small style={{ fontSize: 12, color: curta ? 'var(--atencao)' : 'var(--texto-3)' }}>
                {curta
                  ? `faltam ${8 - senhaNova.length} ${8 - senhaNova.length === 1 ? 'caractere' : 'caracteres'}`
                  : 'pelo menos 8 caracteres — uma que você lembre sem anotar'}
              </small>
            </div>

            <div className="campo">
              <label htmlFor="repetir">Repita a nova senha</label>
              <input id="repetir" type="password" autoComplete="new-password" required
                value={repetida} onChange={(e) => setRepetida(e.target.value)} />
              {diferem && <small style={{ fontSize: 12, color: 'var(--atencao)' }}>as duas não estão iguais</small>}
            </div>

            {erro && <p className="aviso-erro">{erro}</p>}

            <button className="botao" type="submit" disabled={!podeSalvar}>
              {salvando ? 'Salvando…' : 'Criar a senha e entrar'}
            </button>
            <p style={{ color: 'var(--texto-3)', fontSize: 12, lineHeight: 1.5, margin: 0 }}>
              Este link vale uma vez só. Depois de criada, a senha é só sua — ninguém mais a vê.
            </p>
          </>
        )}
      </form>
    </main>
  );
}
